import { Form } from 'formik';
import { FormikDebounce } from '../common/form/FormikDebounce';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { validations } from '../../utils/validations';
import { Modal as QcsModal } from '@mui/material';

import { QcsModalBox } from '../common/basic/QcsModalBox';
import { EmployeeAutocomplete } from '../common/form/EmployeeAutocomplete';
import { FormContainer } from '../common/form/FormContainer';
import { SubmitButton } from '../common/form/SubmitButton';
import { SectionHeader } from '../common/SectionHeader';
import * as Yup from 'yup';
import { EmployeeDto } from '@api/models/employees/EmployeeDto';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';
import { employeeService } from '@api/services/services';
import { ShowError } from '../ShowError';
import { resources } from '@api/resources';

interface EstablishmentDetailFromEmployeeModalForm {
  supplierEmployee?: ReferenceDto | null;
}

interface Props {
  open: boolean;
  onClose: (employee?: EmployeeDto) => void;
}

export const EstablishmentDetailFromEmployeeModal: FC<Props> = ({ open, onClose }) => {
  const { t } = useTranslation();

  const handleSubmit = async (data: EstablishmentDetailFromEmployeeModalForm) => {
    const res = await employeeService.getById(data.supplierEmployee!.id!);
    onClose(res.data);
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <QcsModal open={open} onClose={handleClose}>
      <QcsModalBox>
        <SectionHeader title="establishment.loadFromEmployeeTitle" />
        <FormikDebounce<EstablishmentDetailFromEmployeeModalForm>
          initialValues={{
            supplierEmployee: null,
          }}
          validationSchema={Yup.object().shape({
            supplierEmployee: validations.objectRequired(t),
          })}
          onSubmit={handleSubmit}
        >
          <Form>
            <FormContainer>
              <EmployeeAutocomplete
                name="supplierEmployee"
                label={t('establishment.loadFromEmployeeLabel')}
                filterOutNonHumanRoles={true}
                required={true}
              />

              <ShowError resource={resources.getEmployee} />
              <SubmitButton text="establishment.loadFromEmployeeSelect" />
            </FormContainer>
          </Form>
        </FormikDebounce>
      </QcsModalBox>
    </QcsModal>
  );
};
